import type { DateTime } from "luxon";
import IdentityObject from "@/src/domain/common/identity-object";

export default abstract class UserService extends IdentityObject {
  abstract loadUserInfo(): Promise<boolean>;

  abstract get deleteAccountTime(): DateTime | null;

  abstract get userId(): number | null;

  abstract get email(): string | null;

  abstract get isLoaded(): boolean;

  abstract scheduleAccountDeletion(): Promise<void>;

  abstract immediateAccountDeletion(): Promise<void>;

  abstract cancelAccountDeletion(): Promise<void>;

  abstract changePassword(oldPassword: string, newPassword: string): Promise<void>;
}
